var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty",style:({height: _vm.height+'px'})},[_c('a-empty',{attrs:{"image":_vm.image,"image-style":{
    height:_vm.imgHeight+'px' ,
  }}},[_c('span',{attrs:{"slot":"description"},slot:"description"},[_vm._v(_vm._s(_vm.desc))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8de737a4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/public/AntdvEmpty.vue
// module id = null
// module chunks = 